import { z as zod } from "zod";
import parsePhoneNumber from 'libphonenumber-js';

export const PhoneNumberSchema = zod.custom<string>(
    (value) => typeof value === 'string' && parsePhoneNumber(value, 'DE')?.isValid(),
    { message: 'Keine gültige Telefonummer' }
);

export const PhoneSchema = zod.object({
    id: zod.string(),
    number: PhoneNumberSchema,
    reachabilityHint: zod.string().nullish(),
})

